<mat-form-field appearance="outline" #field="matFormField">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    readonly
    [value]="text()"
    [disabled]="disabled()"
    (click)="open()"
    (keydown.enter)="open()"
    (keydown.alt.arrowdown)="open()"
  />
  @if (disabled()) {
    <mat-icon matSuffix aria-hidden="true">lock</mat-icon>
  } @else {
    <button
      mat-icon-button
      matSuffix
      type="button"
      [seiriDateTimePicker]="mode()"
      [pickerValue]="value()"
      [pickerMin]="min()"
      [pickerMax]="max()"
      [pickerStartAt]="startAt()"
      [pickerStartView]="startView()"
      [pickerOrigin]="field.getConnectedOverlayOrigin()"
      [attr.aria-label]="triggerLabel()"
      (picked)="pick($event)"
      (closed)="touch()"
    >
      <mat-icon>{{ icon() }}</mat-icon>
    </button>
  }
</mat-form-field>
